/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';

import { TranslationContext } from 'bundles/ondemand-translation/components/TranslationContextProvider';

import _t from 'i18n!nls/peer';

const styles = {
  bannerWrapper: css`
    margin-top: var(--cds-spacing-150);
  `,
};

type Props = {
  errorMessage?: string;
};

const TranslationFailedNotification = (props: Props) => {
  const context = React.useContext(TranslationContext);

  if (!context?.progressTracker.hasError) {
    return null;
  }
  const { errorMessage = _t("This can't be translated right now. Try again later"), ...rest } = props;

  return (
    <InlineNotification severity="error" css={styles.bannerWrapper} {...rest}>
      {errorMessage}
    </InlineNotification>
  );
};

export default TranslationFailedNotification;
